module.exports = "<div [perfectScrollbar] >\n  <clemos-lead-list-item [lead]=\"lead\" *ngFor=\"let lead of leads\"></clemos-lead-list-item>\n</div>\n"